<div class="dialog">
  <form [formGroup]="form">
    <h4 mat-dialog-title style="margin-top: 20px">{{ 'dialog_solution_scenario_title_solution' | translate }}</h4>
    <mat-card>
      <mat-form-field appearance="fill">
        <mat-label>{{ 'common_field_solution' | translate }}</mat-label>
        <mat-select panelClass="long-panel" [(ngModel)]="data.currentSolution" [value]="data?.currentSolution" [ngModelOptions]="{ standalone: true }" required formControlName="selectedSolution">
          <div class="row m-2 mt-3 mb-1">
            <div class="col-6">
              <mat-form-field>
                <mat-label color="accent">{{ 'dialog_select_solution_filter_placeholder' | translate }}</mat-label>
                <input matInput (keydown)="$event.stopPropagation()" (keyup)="search($event.target)" />
              </mat-form-field>
            </div>
          </div>
          <mat-optgroup class="solution-label" *ngFor="let project of filteredProjects" [label]="project.displayName" [disabled]="project.disabled">
            <mat-option *ngFor="let solution of project.solutions" [value]="solution">
              {{ solution.displayName }}
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
    </mat-card>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="data?.currentSolution" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
      <!-- <button mat-button [mat-dialog-close]="data?.currentSolution" color='accent'>Enregistrer</button> -->
    </div>
  </form>
</div>
